/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-expedia': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<metadata id="metadata62"/><g id="g212" transform="matrix(.91504 0 0 .91504 -1278.9 -1268.991)" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><g id="g277" transform="translate(1398.736 1395.556) scale(.06486)"><g id="g282"><path pid="0" id="path4398" class="st0" d="M138 90.6l-4.7-13.4-40.4-53.9 7.2-1.8 69.5 60.1 40.9-11.7c4.8-1.2 10.3-1.5 14.4-1.5-12.8-27.7-36.4-50.5-67.4-61.5C96.2-15 28.7 17.1 6.9 78.5c-6.8 19-8.3 38.6-5.5 57.2l97.9-34z" _fill="#000"/><path pid="1" id="path4402" class="st0" d="M229.3 79c-3.6 2.3-8.9 5.4-14.1 7.1l-41 11.7-27.3 87.8-7.1 2.3 5.8-67-3.2-13.9-38.4 11L2.4 141.7c8.1 39 35.7 73.1 76 87.4 61.4 21.9 128.8-10.2 150.7-71.6 9.4-26.3 8.8-53.9.2-78.5" _fill="#000"/><path pid="2" id="path4406" class="st1" d="M142.3 106.9l3.2 13.9-5.8 67 7.1-2.3 27.3-87.8 41-11.7c5.2-1.7 10.5-4.7 14.1-7.1-1.3-3.6-2.7-7.1-4.3-10.6-4.2 0-9.6.2-14.4 1.5l-40.9 11.7-69.5-60.1-7.2 1.8 40.3 53.9 4.7 13.4-38.7 11.1-97.9 34c.3 2 .7 4.1 1.1 6.1l101.5-23.9z" _fill="#fff"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-expedia.js